import React, { useEffect, useState } from "react";
import { CFormSelect } from "@coreui/react";
import { Language } from "../../language/English";
import { EMPLOYEE_PUBLIC_IMAGE} from "../../services/Business/Image/ImageConstant";
const ManageEmployeeImageSortDropdown = React.forwardRef((props: { onChangeHandler : Function, dropdownValue : number|null, showWarning? : string }, ref) => {
    const [ dropdownValue, setDropdownValue ] = useState<number>(0);
    useEffect(() => {
        if(props.dropdownValue === null) {
            setDropdownValue(0);
        } else {
            setDropdownValue(props.dropdownValue);
        }
    },  [props.dropdownValue])

    return (
        <CFormSelect value={dropdownValue} onChange={(e) => props.onChangeHandler(e.target.value)}>
            <option value={0} key={0}>{Language.SHOW_ALL}</option>
            <option value={EMPLOYEE_PUBLIC_IMAGE} key={EMPLOYEE_PUBLIC_IMAGE}>{Language.EMPLOYEE_MISSING_PUBLIC_IMAGE}</option>
         </CFormSelect>
    )
})
export default ManageEmployeeImageSortDropdown;